import React,{useEffect,useState} from 'react';
import './comp_cadet_record_book.css'

export const Comp_CRB_Realtime=(props)=>{
    let _semCheck="";
    let _functionCheck="";
    let _divIndexNm="";
    useEffect(()=>{
        //alert(JSON.stringify(props.task_list));
    },[props.task_list]);
    
    return(
        <section>

        {/* div-1  */}
        <div class="saperate-page div1 text-start">
        <table>
            <td>
                
            </td>
        </table>
    </div>
        {/* div-2  */}
        
        {/* <div class="saperate-page container-fluid div-2">
        <h5 class="text-center mb-3">INDEX</h5>
        
       
    </div> */}
        
        {/* div-3  */}

        
        {/* div-4  */}
        
       
    
    {/* div-5  */}

    <div class="saperate-page section3-table div-5 text-start">
        <h5>SECTION 3</h5>
        <h5>3.1: Cadet's Particulars</h5>
        
        <p>Particulars of Cadet to be completed by the Cadet in BLOCK letters:</p>
       {typeof props.cadetAllCRB.student_record!=="undefined"? 
        <table class="form-table">
            <tr>
                <td>
                    <div class="form-field">
                        Full Name: <input type="text" defaultValue={props.cadetAllCRB.student_record[0]["full_name"]}/>
                    </div>
                    {/* <div class="form-field">
                        Middle Name: <input type="text" defaultValue={props.cadetAllCRB.student_record[0]["middle_name"]}/>
                    </div> */}
                    {/* <div class="form-field">
                        Last Name: <input type="text" defaultValue={props.cadetAllCRB.student_record[0]["last_name"]}/>
                    </div> */}
                </td>
            </tr>
            <tr>
                <td>
                    <div class="form-field">
                        Date of Birth: <input type="text" defaultValue={props.cadetAllCRB.student_record[0]["dob"]}/>
                    </div>
                    <div class="form-field">
                        Place of Birth: <input type="text" defaultValue={props.cadetAllCRB.student_record[0]["bith_place"]}/>
                    </div>
                </td>
            </tr>
            <tr>
                <td>
                    <div class="form-field">
                        Passport No.: <input type="text" defaultValue={props.cadetAllCRB.student_record[0]["passport_no"]} />
                    </div>
                    <div class="form-field">
                        CDC No.: <input type="text" defaultValue={props.cadetAllCRB.student_record[0]["mem_no"]}/>
                    </div>
                    <div class="form-field">
                        INDOS No.: <input type="text" defaultValue={props.cadetAllCRB.student_record[0]["indos_no"]}/>
                    </div>
                </td>
            </tr>
            <tr>
                <td>
                    <div>Home Address:</div>
                    <input type="text" class="long-field" defaultValue={props.cadetAllCRB.student_record[0]["home_address"]} />
                    
                </td>
            </tr>
            <tr>
                <td>
                    <div class="form-field">
                        Phone: <input type="text" defaultValue={props.cadetAllCRB.student_record[0]["mobile_no"]}/>
                    </div>
                    <div class="form-field">
                        Fax: <input type="text" defaultValue={props.cadetAllCRB.student_record[0]["fax_no"]}/>
                    </div>
                    <div class="form-field">
                        E-mail: <input type="text" defaultValue={props.cadetAllCRB.student_record[0]["email_addr"]}/>
                    </div>
                </td>
            </tr>
            <tr>
                <td>
                    <div class="form-field">
                        Commenced Date: <input type="text" defaultValue={props.cadetAllCRB.student_record[0]["commenced_date"]}/>
                    </div>
                    <div class="form-field">
                        Height: <input type="text" defaultValue={props.cadetAllCRB.student_record[0]["height_cm"]} style={{width: '50px'}}/> cm.
                    </div>
                    <div class="form-field">
                        Weight: <input type="text" defaultValue={props.cadetAllCRB.student_record[0]["weight_kg"]} style={{width: '50px'}}/> Kg
                    </div>
                    <div class="form-field">
                        Blood Group: <input type="text" defaultValue={props.cadetAllCRB.student_record[0]["blood_group"]}/>
                    </div>
                </td>
            </tr>
            <tr>
                <td>
                    <div>Distinguishing Marks: <input type="text" defaultValue={props.cadetAllCRB.student_record[0]["distinguishing_mark"]} class="long-field"  style={{width: '70%'}}/></div>
                </td>
            </tr>
            <tr>
                <td>
                    <div>Sponsoring Company: <input type="text" class="long-field"  style={{width: '70%'}}/></div>
                </td>
            </tr>
            <tr>
                <td>
                    <div>Address: <input type="text" class="long-field"/></div>
                    <input type="text" class="long-field"/>
                </td>
            </tr>
            <tr>
                <td>
                    <div>Name, Address and Relationship of Next of Kin: <input type="text" class="long-field"  style={{width: '50%'}}/></div>
                    <input type="text" class="long-field"/>
                </td>
            </tr>
            <tr>
                <td>
                    <div class="form-field">
                        Phone: <input type="text"/>
                    </div>
                    <div class="form-field">
                        Fax: <input type="text"/>
                    </div>
                    <div class="form-field">
                        E-mail: <input type="text"/>
                    </div>
                </td>
            </tr>
        </table>:''}
    </div>


 {/* div-6  */}
        
 <div class="div-6 saperate-page text-start">
        <h5>3.2 Educational Record</h5>
        
        <p><strong>GCE "O" level / Class X</strong></p>
        
        <div class="form-field">
            <span class="field-label">Name and address of the school:</span>
            <span class="input-line">&nbsp;</span>
        </div>
        
        <div class="form-field">
            <span class="field-label">Date certificate issued:</span>
            <span class="input-line">&nbsp;</span>
        </div>
        
        <table>
            <tr>
                <th>Subjects</th>
                <th>Grade/ Marks</th>
            </tr>
            <tr class="empty-row"><td></td><td></td></tr>
            <tr class="empty-row"><td></td><td></td></tr>
            <tr class="empty-row"><td></td><td></td></tr>
            <tr class="empty-row"><td></td><td></td></tr>
            <tr class="empty-row"><td></td><td></td></tr>
            <tr class="empty-row"><td></td><td></td></tr>
            <tr class="empty-row"><td></td><td></td></tr>
        </table>
        
        <p><strong>GCE "A" level / Class XII</strong></p>
        
        <div class="form-field">
            <span class="field-label">Name and address of the school:</span>
            <span class="input-line">&nbsp;</span>
        </div>
        
        <div class="form-field">
            <span class="field-label">Date certificate issued:</span>
            <span class="input-line">&nbsp;</span>
        </div>
        
        <table>
            <tr>
                <th>Subjects</th>
                <th>Grade/ Marks</th>
            </tr>
            <tr class="empty-row"><td></td><td></td></tr>
            <tr class="empty-row"><td></td><td></td></tr>
            <tr class="empty-row"><td></td><td></td></tr>
            <tr class="empty-row"><td></td><td></td></tr>
            <tr class="empty-row"><td></td><td></td></tr>
            <tr class="empty-row"><td></td><td></td></tr>
        </table>
    </div>

{/* div-7  */}

<div class="div-7 saperate-page text-start">
    <h5>3.3 Professional Training Record</h5>
    <div class="section-title">Cadet's Training Programme</div>
    
   
    <table>
        <tr>
            <th>Pre-Sea Training<br/>Name of the College</th>
            <th>Date (From)</th>
            <th>Date (To)</th>
        </tr>
        <tr class="empty-row"><td></td><td></td><td></td></tr>
    </table>
    
    
    <table>
        <tr>
            <th>On-Board Training<br/>Name of the Ship</th>
            <th>Date (From)</th>
            <th>Date (To)</th>
        </tr>
        <tr class="empty-row"><td></td><td></td><td></td></tr>
        <tr class="empty-row"><td></td><td></td><td></td></tr>
        <tr class="empty-row"><td></td><td></td><td></td></tr>
        <tr class="empty-row"><td></td><td></td><td></td></tr>
    </table>
    
   
    <div class="section-title">Basic Training as Required by STCW 2010- Section A-VI/1</div>
    <table>
        <tr>
            <th>Course</th>
            <th>Date</th>
            <th>Name of Institution</th>
            <th>Location</th>
            <th>Certificate number</th>
        </tr>
        <tr>
            <td>Personal Survival Techniques</td>
            <td></td><td></td><td></td><td></td>
        </tr>
        <tr>
            <td>Fire prevention and Fire fighting</td>
            <td></td><td></td><td></td><td></td>
        </tr>
        <tr>
            <td>Elementary First Aid</td>
            <td></td><td></td><td></td><td></td>
        </tr>
        <tr>
            <td>Personal Safety and Social Responsibilities</td>
            <td></td><td></td><td></td><td></td>
        </tr>
        <tr>
            <td>Security Training for persons with designated duties</td>
            <td></td><td></td><td></td><td></td>
        </tr>
    </table>
    
   
    <div class="section-title">Record of Other Professional Training</div>
    <table>
        <tr>
            <th>Course</th>
            <th>Date</th>
            <th>Name of Institution</th>
            <th>Location</th>
            <th>Certificate number</th>
        </tr>
        <tr>
            <td>Proficiency in Survival Craft & Rescue Boat</td>
            <td></td><td></td><td></td><td></td>
        </tr>
        <tr>
            <td>Radar Observer Course</td>
            <td></td><td></td><td></td><td></td>
        </tr>
        <tr>
            <td>Automatic Radar Plotting Aids</td>
            <td></td><td></td><td></td><td></td>
        </tr>
        <tr>
            <td>Medical First Aid</td>
            <td></td><td></td><td></td><td></td>
        </tr>
        <tr>
            <td>GMDSS General Operator's Certificate</td>
            <td></td><td></td><td></td><td></td>
        </tr>
        <tr>
            <td>Oil and Chemical Tanker Familiarization</td>
            <td></td><td></td><td></td><td></td>
        </tr>
        <tr>
            <td>Gas Tanker Familiarization</td>
            <td></td><td></td><td></td><td></td>
        </tr>
    </table>
   </div>

{/* div-8  */}

<div class="div-8 saperate-page text-start">
        <div class="title">3.4 Record of Sea Service</div>
    
    <table>
        <thead>
            <tr>
                <th rowspan="2" class="ship-col">Ship</th>
                <th rowspan="2" class="imo-col">IMO Number</th>
                <th colspan="2" class="date-col">Date</th>
                <th colspan="2" class="time-header">Time spent on bridge watchkeeping duties</th>
                <th colspan="2" class="time-header">Voyage total seagoing service</th>
            </tr>
            <tr>
                <th>Signed on</th>
                <th>Signed off</th>
                <th>Months</th>
                <th>Days</th>
                <th>Months</th>
                <th>Days</th>
            </tr>
        </thead>
        <tbody>
            <tr class="empty-row">
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
            </tr>
          
            
            <tr class="total-row">
                <td colspan="4">Total Time</td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
            </tr>
        </tbody>
    </table>
    </div>

{/* div-9  */}


<div class="div-9 saperate-page text-start">
        <div class="section-title">SECTION 4</div>
        <div class="sub-title">4.1 Shipboard Training Officer's Monthly Review of the Record Book</div>
        <div class="instructions">
            Comments should only relate to the Cadet's practical progress in training and competence.<br/>
            (The first two rows give examples of monthly entries)
        </div>
        
        <table>
            <thead>
                <tr>
                    <th style={{width: '5%'}}></th>
                    <th style={{width: '15%'}}>Ship</th>
                    <th style={{width: '30%'}}>Comments</th>
                    <th style={{width: '20%'}}>Shipboard Training Officer's Name</th>
                    <th style={{width: '20%'}}>Shipboard Training Officer's Signature and Stamp</th>
                    <th style={{width: '10%'}}>Date</th>
                </tr>
            </thead>
            <tbody>
               
                <tr>
                    <td>1.</td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                </tr>
              
            </tbody>
        </table>
    </div>

 {/* div-10  */}
 <div class="div-10 saperate-page text-start">
        <div class="header">
            <h2>4.2 Master's Monthly Review of the Record Book</h2>
        </div>
        
        <div class="instructions text-start">
            Comments should only relate to Cadet's practical progress in training and competence.<br/>
            (First two rows indicate examples of filling the monthly review)
        </div>
        
        <table>
            <thead>
                <tr>
                    <th width="5%"></th>
                    <th width="15%">Ship</th>
                    <th width="30%">Comments</th>
                    <th width="15%">Master's Name</th>
                    <th width="15%">Master's Signature</th>
                    <th width="10%">Date</th>
                    <th width="15%">Ship's Official Stamp</th>
                </tr>
            </thead>
            <tbody>
               
                <tr>
                    <td>1.</td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                </tr>
                
            </tbody>
        </table>
        
    </div>

{/* div-11  */}
<div class="div11 saperate-page text-start">
    <h6>4.3 Company's/ Maritime Training Institution’s Review of the Record Book</h6>
    <p class="note">Comments should only relate to the Cadet’s practical progress in training and competence.</p>

    <table>
        <thead>
            <tr>
                <th>Comments</th>
                <th>Name</th>
                <th>Designation</th>
                <th>Signature</th>
                <th>Date</th>
            </tr>
        </thead>
        <tbody>
            <tr>
                <td style={{height: '50px'}}></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
            </tr>
         
        </tbody>
    </table>

   
</div>

{/* div-12  */}
<div class="div-12 saperate-page text-start">
<h6>4.4 Task Summary Record</h6>
<p>The purpose of this summary record is to provide a continuous check on the status of the tasks. The Cadet should tick the tasks successfully completed. The
wlor wde for the tasks is:<br/>
Semester 3: Yellow<br/>
Semester 4: Green<br/>
Semester 5: Blue<br/>
Each phase is of 6 months. There is no colour codlng for specialized ships as the tasks on such ships are not segregated into phases.
The task summary record should be used for recording the tasks completed in Section 8 and be kept updated. In the boxes below the task number, tick off
those tasks which are completed and signed by the ST0 (In section 8).<br/>
Every quarter, the cadet needs to make a photocopy of all the Task Summary sheets (4.4.8 Summarv Record of all taskg). He shall then get these
photowp~ed Summary sheets signed, dated, stamped and attested by the STO. These may then be sent by post or a scanned oopy by email to the Company
Training Officer (CTO) who in turn will pass it to his Pre-Sea Maritime Training Institute.<br/>
Specimen signatures of all officers who have signed on this record book should be documented in the table below. 
</p>
</div>

{/* div-13  */}
<div class="div-13 saperate-page text-start">
<h5>4.4 A Record of Specimen signatures </h5>
<table>
        
        <thead>
            <tr>
                <th>Vessel Name</th>
                <th>Name of Officer</th>
                <th>Rank</th>
                <th>Specimen Signature</th>
                <th>Date Signed On</th>
                <th>Date Signed Off</th>
            </tr>
        </thead>
        <tbody>
 
            <tr><td></td><td></td><td></td><td></td><td></td><td></td></tr>
            
        </tbody>
    </table>
</div>


{/* div-14  */}
<div class="div-14 saperate-page text-start">
    <h5 class="text start">TASK SUMMARY RECORD</h5>

    {props.task_list.map((m_item,m_index)=>{
        
        let semCheck=m_item["top_cats"].split('>');
        let divClass="div_"+semCheck[0];
        if(_semCheck!==semCheck[0]){
            _divIndexNm=divClass;
        }
      //alert(semCheck[0]+" == "+_semCheck);
        return <div class={_divIndexNm+" text-start"}>
{_semCheck!==semCheck[0]?<h5 class="text start mt-5 mb-5">{semCheck[0]}</h5>:''}
    {_functionCheck!==semCheck[1]?<h6 class="text start pt-3 pb-3">{semCheck[1]}</h6>:''}
    <div class={"text start"}>
        <table class="table11">
            <tbody>
                {props.task_list.map((item,index)=>{
                    
if(semCheck.length>=2){
    if(_semCheck!==semCheck[0]){
        _semCheck=semCheck[0];
    }
    if(_functionCheck!==semCheck[1]){
        _functionCheck=semCheck[1];
    }
    
}

if(m_item["top_cats"]===item["top_cats"]){
    let subTasks=JSON.parse(item["subtasks"]);
    return <tr>
        <td style={{"width":"50%"}}>{item["category_name"]}</td>
        <td style={{"max-width":"100px"}}>
            {subTasks.map((subItem,subIndex)=>{
                let taskNos=subItem["study_m_sub_task_nos"].split(',');
                return <>{
                
                taskNos.map((taskNos,taskNosIndex)=>{
                    return <span class="highlighted_task"><a class="chrf" chrf={"https://lmstestd.bhandarkarpublications.com/controller/test_reader.php?pm=demReadBookMUI&rf="+btoa(subItem["study_m_id"])+"&rd_index=undefined"}>{taskNos}</a></span>
                })
            }</>
            })}
        </td>
    </tr>
}

                    
                  
                })}
            </tbody>
        </table>
    </div>
    </div>
        


    })}
    


   
    
   </div>



{/* div-15  */}

{/* div -16  */}


{/* div-17  */}
   
{/* div-18  */}


{/* div-19  */}

    



        </section>
    );
}

export default Comp_CRB_Realtime